import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Row,
  Col,
  InputGroup,
  Label,
  Container,
  CardBody,
  Card,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  getMediaBuyerBudgetsById,
  getMediaBuyerDataForAdd,
  patchMediaBuyerBudget,
} from "./../../../../store/mediabuyers/mediabuyerbudget/actions";
import { getOffers } from "../../../../store/offers/actions";
import Select from "react-select";
import { setMediaBuyerBudgetsForId } from "../../../../store/mediabuyers/mediabuyerbudget/actions";

const EditMediaBuyer = props => {
  const [mediaBuyerSelect, setMediaBuyerSelect] = React.useState(null);
  const [offerSelect, setOfferSelect] = React.useState(null);
  const [rangeDate, setRangeDate] = React.useState(null);

  let state = {
    isFormSubmit: false,
  };

  React.useEffect(() => {
    const client_id = props.match.params.id;
    props.getMediaBuyerBudgetsById(client_id);
    props.getMediaBuyerDataForAdd();
    props.getOffers({
      ...props.offers,
      is_main: false,
    });

    return () => {
      setMediaBuyerSelect(null);
      setOfferSelect(null);
      setRangeDate(null);
      props.setMediaBuyerBudgetsForId(null);
    };
  }, []);

  React.useEffect(() => {
    if (props.dataForAddBudget === null) {
      const client_id = props.match.params.id;
      props.getMediaBuyerBudgetsById(client_id);
      props.getMediaBuyerDataForAdd();
    }
    if (mediaBuyerSelect === null && props.client_budget !== null) {
      if (props.dataForAddBudget !== null) {
        let inx = props.dataForAddBudget.mediaBuyers.findIndex(
          x => x.id === props.client_budget.media_buyer
        );
        setMediaBuyerSelect({
          label: props.dataForAddBudget.mediaBuyers[inx].number,
          value: props.dataForAddBudget.mediaBuyers[inx].id,
        });
      }
    }
    if (
      offerSelect === null &&
      props.client_budget !== null &&
      props.offers.length !== undefined
    ) {
      if (props.dataForAddBudget !== null) {
        let inx = props.offers.findIndex(
          x => x.id === props.client_budget.offer
        );
        setOfferSelect({
          label: props.offers[inx].name,
          value: props.offers[inx].id,
        });
      }
    }
    if (rangeDate === null) {
      props.client_budget &&
        setRangeDate({
          date: props.client_budget.date_range,
        });
    } else {
      props.client_budget &&
        setRangeDate({
          date: props.client_budget.date_range,
        });
    }
  }, [props.dataForAddBudget, props.client_budget, props.offers]);

  const getOfferTypes = item => {
    let offer = [];
    if (props.offers.length !== undefined) {
      item.map(i => {
        offer.push({ label: i.name, value: i.id });
      });
    }
    return offer;
  };

  const getMediaBuyers = item => {
    let media = [];
    item.mediaBuyers.map(i => {
      media.push({ label: i.number, value: i.id });
    });
    return media;
  };

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    if (errors?.length === 0) {
      let data = {
        offer: offerSelect.value,
        media_buyer: mediaBuyerSelect.value,
        budget: params.budget,
        date_range: rangeDate.date,
      };
      const client_id = props.match.params.id;
      props.patchMediaBuyerBudget(client_id, data);
      return props.history.push(`/media-buyer-budget/`);
    }
  };

  return (
    <div className="page-content">
      {props.client_budget && (
        <Container fluid>
          <Breadcrumbs
            title="Media buyer budgets"
            breadcrumbItem={`${props.client_budget.media_buyer}`}
            link="/media-buyer-budget"
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation" onSubmit={onSubmitForm}>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="offer">Offer</Label>
                          <Select
                            value={offerSelect}
                            onChange={setOfferSelect}
                            isLoading={offerSelect === null}
                            required
                            options={
                              props.dataForAddBudget !== null &&
                              getOfferTypes(props.offers)
                            }
                            classNamePrefix="select2-selection"
                            isFormSubmit={state.isFormSubmit}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="offer">Media buyer</Label>
                          <Select
                            name="mediaBuyer"
                            options={
                              props.dataForAddBudget !== null &&
                              getMediaBuyers(props.dataForAddBudget)
                            }
                            value={mediaBuyerSelect}
                            onChange={setMediaBuyerSelect}
                            required
                            isLoading={mediaBuyerSelect === null}
                            isFormSubmit={state.isFormSubmit}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="budget"
                            label="Budget"
                            type="number"
                            value={
                              props.client_budget &&
                              props.client_budget.budget.toString()
                            }
                            errorMessage="Invalid budget"
                            validate={{
                              required: { value: true },
                              minLength: {
                                value: 1,
                                errorMessage: "Min 1 number",
                              },
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Date Range</Label>
                          <InputGroup>
                            <Flatpickr
                              name="date"
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              value={rangeDate && rangeDate.date}
                              options={{
                                mode: "range",
                                dateFormat: "d-m-Y",
                              }}
                              style={{ backgroundColor: "white" }}
                              onChange={(date, dateStr) =>
                                setRangeDate({ date: dateStr })
                              }
                            />
                          </InputGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-success save-user"
                          >
                            Save changes
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

EditMediaBuyer.propTypes = {
  history: PropTypes.object,
  data: PropTypes.object,
  getMediaBuyerBudgetsById: PropTypes.func.isRequired,
  match: PropTypes.object,
  client_budget: PropTypes.object,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  dataForAddBudget: PropTypes.object,
  patchMediaBuyerBudget: PropTypes.func.isRequired,
  getOffers: PropTypes.func.isRequired,
  offers: PropTypes.any,
  setMediaBuyerBudgetsForId: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  offers: state.Offers.offers,
  data: state.MediaBuyerBudgets.data,
  client_budget: state.MediaBuyerBudgets.client_budget,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
});

export default connect(mapStateToProps, {
  getMediaBuyerBudgetsById,
  getMediaBuyerDataForAdd,
  getOffers,
  patchMediaBuyerBudget,
  setMediaBuyerBudgetsForId,
})(EditMediaBuyer);
